module.exports = __webpack_public_path__ + "static/media/mobile-php.1fa7b101.JPG";